import { Icon } from "./Icon.tsx";

/** "Rectangle select" tool icon — a dashed marquee rectangle. */
export function SelectRectangleIcon() {
  return (
    <Icon>
      <rect x="4" y="5" width="16" height="14" rx="1" strokeDasharray="3 2.5" />
    </Icon>
  );
}
